var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearEarPlugAndGoggles50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,21v2h1c0,3.5,2.5,5,4,5c1,0,1,0,2,0c3-0.001,2.5-3,4-3s1,2.999,4,3c1,0,1,0,2,0c1.5,0,4-1.5,4-5 h1v-2H13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11,21c-1.654,0-3,1.346-3,3v4c0,1.654,1.346,3,3,3h4V21H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37,21h-4v10h4c1.654,0,3-1.346,3-3v-4C40,22.346,38.654,21,37,21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,21.202V20c0-6.617-5.383-12-12-12s-12,5.383-12,12v1.202c-1.202,0.513-2,1.954-2,3.798 c0,2.977,1.948,5.111,3.18,5.926C15.384,36.885,20.253,40,24,40c3.746,0,8.616-3.115,10.82-9.074C36.052,30.111,38,27.977,38,25 C38,23.156,37.202,21.715,36,21.202z M33.553,29.355l-0.364,0.183l-0.133,0.385C31.019,35.808,26.42,38,24,38 s-7.02-2.192-9.055-8.077l-0.133-0.385l-0.365-0.183C14.044,29.154,12,27.588,12,25c0-0.983,0.374-2,1-2h2v-3c0-4.963,4.038-9,9-9 s9,4.037,9,9v3h2c0.626,0,1,1.017,1,2C36,27.588,33.956,29.154,33.553,29.355z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearEarPlugAndGoggles50);
export default __webpack_public_path__ + "static/media/icons8-wear-ear-plug-and-goggles-50.36a92f60e5af1c2a2dc5d655ddaea9ea.svg";
export { ForwardRef as ReactComponent };